import { render, staticRenderFns } from "./SectionNavigationVertical.vue?vue&type=template&id=2271f1d2&"
import script from "./SectionNavigationVertical.vue?vue&type=script&lang=ts&"
export * from "./SectionNavigationVertical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports